import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<SpinnerSvg @spinning={{true}} @size=\"x-large\" />",{ moduleName: "unattended-showing/context/logout/template.hbs" })